import MetadataManager from './common/MetadataManager';
import { useTranslation } from 'react-i18next';

export default function SourceManagement() {
  const { t } = useTranslation();

  return (
    <MetadataManager
      title={t('settings.sourceManagement.title')}
      type="sources"
      description={t('settings.sourceManagement.description')}
    />
  );
}
